export interface ReviewSite {
  slug: string;
  name: string;
  tagline: string;
  category: string;
  rating: number;
  ads: { score: number; desc: string };
  speed: { score: number; desc: string };
  content: { score: number; desc: string };
  sincere: { score: number; desc: string };
  summary: string;
  desc: string;
  pros: string[];
  cons: string[];
  img: string;
  badge?: string;
}

export const reviewSites: ReviewSite[] = [
  {
    slug: "manyue-ge",
    name: "漫阅阁",
    tagline: "页面干净、广告克制的人气站",
    category: "综合在线漫画",
    rating: 4.8,
    ads: { score: 5, desc: "广告极少，翻页基本无弹窗" },
    speed: { score: 5, desc: "图片走 CDN，加载流畅" },
    content: { score: 5, desc: "中日漫、韩漫、条漫齐全" },
    sincere: { score: 5, desc: "无需下载 App 即可阅读" },
    summary:
      "综合体验非常均衡的一家，广告控制优秀，翻页几乎不被打扰，加载速度在同类型站点里属于第一梯队。",
    desc: "漫阅阁是目前口碑比较好的在线漫画阅读站之一。最让人满意的点是广告控制：常规页面几乎看不到侵入式广告，翻页过程中也很少出现弹窗，阅读节奏不会被突然打断。加载方面图片使用 CDN 分发，连播翻页时基本不需要等待。内容覆盖日漫、国漫、韩漫和条漫，热门作品更新也比较及时。整体属于「良心站」的典型代表。",
    pros: ["广告克制、翻页清净", "图片加载流畅", "内容更新及时", "无需下载即可阅读"],
    cons: ["部分冷门作品收录较慢", "偶尔需要登录收藏"],
    img: "https://readdy.ai/api/search-image?query=vibrant%20anime%20comic%20manga%20cover%20illustration%20with%20young%20characters%20reading%20books%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20clean%20flat%20art%20style%2C%20soft%20lighting%2C%20modern%20editorial%20composition&width=800&height=600&seq=manyuege-cover&orientation=landscape",
    badge: "编辑力荐",
  },
  {
    slug: "manyu-yuan",
    name: "漫语源",
    tagline: "国漫、韩漫爱好者聚集地",
    category: "国漫韩漫专题",
    rating: 4.6,
    ads: { score: 4, desc: "广告较少，底部偶有横幅" },
    speed: { score: 4, desc: "速度中上，高峰期略慢" },
    content: { score: 5, desc: "国漫与韩漫资源最全" },
    sincere: { score: 4, desc: "基础功能免费使用" },
    summary:
      "国漫和韩漫收录很全，更新频率高，广告量适中，是追国漫的朋友值得试试的选择。",
    desc: "漫语源的强项在国漫与韩漫的收录广度上，许多冷门作品在这里都能找到，更新节奏也比较稳定。广告控制处于中等偏上，日常阅读时底部会出现横幅广告，但不会频繁弹窗打断操作。速度在普通时段表现不错，热门作品连载更新当天会稍有延迟。整体良心程度不错，基础功能都可以免费使用。",
    pros: ["国漫韩漫资源最全", "更新频率稳定", "搜索功能好用"],
    cons: ["高峰期加载略慢", "底部横幅广告偏多"],
    img: "https://readdy.ai/api/search-image?query=colorful%20manhwa%20webtoon%20art%20style%20cover%20with%20diverse%20characters%20and%20comic%20panels%2C%20teal%20and%20amber%20palette%2C%20flat%20vector%20illustration%2C%20clean%20background%2C%20dynamic%20composition&width=800&height=600&seq=manyuyuan-cover&orientation=landscape",
  },
  {
    slug: "zhuifan-wu",
    name: "追番屋",
    tagline: "热门连载追更速度第一",
    category: "日漫连载更新",
    rating: 4.7,
    ads: { score: 4, desc: "广告适中，可接受" },
    speed: { score: 5, desc: "追更当天更新极快" },
    content: { score: 5, desc: "热门日漫连载最全" },
    sincere: { score: 5, desc: "界面清爽，无套路付费" },
    summary:
      "以「更新快」著称，热门日漫连载几乎同步上线，广告量适中，界面也足够清爽。",
    desc: "追番屋的核心卖点是更新速度，热门日漫连载基本能第一时间上线，追更体验很好。广告控制适中，进入阅读页前会有少量广告，但阅读过程中比较克制。加载速度一流，连页阅读流畅。界面设计清爽，没有套路化的付费弹窗，整体属于让人放心的站点。",
    pros: ["连载更新速度极快", "阅读页广告克制", "界面清爽无套路"],
    cons: ["广告出现在阅读入口", "需登录后追更提醒"],
    img: "https://readdy.ai/api/search-image?query=energetic%20anime%20manga%20cover%20with%20action%20scenes%20and%20motion%20lines%2C%20coral%20red%20accent%20and%20cream%20background%2C%20bold%20flat%20illustration%2C%20dynamic%20speed%20lines%2C%20modern%20layout&width=800&height=600&seq=zhuifanwu-cover&orientation=landscape",
    badge: "更新最快",
  },
  {
    slug: "manhua-zhan",
    name: "漫画卷",
    tagline: "界面精致、适合沉浸阅读",
    category: "沉浸阅读体验",
    rating: 4.5,
    ads: { score: 4, desc: "广告较少，界面干净" },
    speed: { score: 4, desc: "加载良好，图质较高" },
    content: { score: 4, desc: "高清资源多" },
    sincere: { score: 4, desc: "免费为主，少量会员" },
    summary:
      "画质与阅读界面是它的强项，适合追求阅读体验的用户，广告量少，整体感受舒适。",
    desc: "漫画卷把功夫花在了阅读体验上：界面精致、排版舒适，漫画图质普遍较高，适合沉浸式阅读。广告控制得不错，页面整体干净。加载速度良好，高清图片也能较快打开。内容覆盖主流作品，更新略慢于头部站点，但资源清晰度更高。",
    pros: ["界面精致体验好", "图质高清", "广告量少"],
    cons: ["更新速度略慢", "会员解锁部分功能"],
    img: "https://readdy.ai/api/search-image?query=minimalist%20elegant%20manga%20reading%20scene%20with%20soft%20paper%20texture%20and%20warm%20lighting%2C%20cream%20and%20teal%20tones%2C%20clean%20flat%20art%2C%20calm%20serene%20composition&width=800&height=600&seq=manhuazhan-cover&orientation=landscape",
  },
  {
    slug: "kuai-man",
    name: "快漫台",
    tagline: "条漫党必看，翻页极快",
    category: "条漫轻量站",
    rating: 4.4,
    ads: { score: 3, desc: "广告偏多，需留意" },
    speed: { score: 5, desc: "轻量加载，速度极快" },
    content: { score: 4, desc: "条漫收录多" },
    sincere: { score: 4, desc: "免费阅读为主" },
    summary:
      "主打条漫，页面轻量加载快，但广告相对多一些，适合不介意偶尔关广告的条漫爱好者。",
    desc: "快漫台定位轻量条漫站，页面结构简单，加载速度极快，翻页体验顺滑，是条漫党的福音。代价是广告相对多一些，翻页间隔偶尔会出现横幅。内容以条漫为主，收录量可观。整体仍然免费可读，良心程度中等偏上。",
    pros: ["条漫加载极快", "翻页顺滑", "收录条漫多"],
    cons: ["广告偏多", "功能相对简单"],
    img: "https://readdy.ai/api/search-image?query=webtoon%20vertical%20comic%20panels%20illustration%20with%20smartphone%20and%20characters%2C%20vibrant%20coral%20and%20amber%20colors%2C%20flat%20modern%20art%2C%20clean%20composition&width=800&height=600&seq=kuaiman-cover&orientation=landscape",
  },
  {
    slug: "manmi-tang",
    name: "漫米堂",
    tagline: "老牌站，资源沉淀丰富",
    category: "老牌综合站",
    rating: 4.3,
    ads: { score: 3, desc: "广告较多" },
    speed: { score: 4, desc: "整体稳定" },
    content: { score: 5, desc: "老作品资源最全" },
    sincere: { score: 4, desc: "长期免费运营" },
    summary:
      "老牌站点，历史作品收录最全，适合找老漫画。广告偏多是短板，需接受一定干扰。",
    desc: "漫米堂是运营多年的老牌站，胜在资源沉淀深厚，很多绝版、老漫画在这里都能找到，是补番怀旧的好去处。短板是广告相对较多，页面横幅与弹窗频率偏高，需要一定的容忍度。加载速度整体稳定，内容覆盖面广，长期免费运营的口碑不错。",
    pros: ["老漫画资源最全", "内容覆盖广", "长期免费"],
    cons: ["广告较多", "界面略显老旧"],
    img: "https://readdy.ai/api/search-image?query=retro%20nostalgic%20vintage%20manga%20bookstore%20shelf%20illustration%2C%20warm%20amber%20and%20cream%20tones%2C%20cozy%20flat%20art%2C%20old%20comic%20books%20stacked%2C%20soft%20lighting&width=800&height=600&seq=manmitang-cover&orientation=landscape",
  },
  {
    slug: "manyu-chao",
    name: "漫语潮",
    tagline: "年轻化设计，新人友好",
    category: "新人友好站",
    rating: 4.5,
    ads: { score: 4, desc: "广告适中" },
    speed: { score: 5, desc: "新一代技术加载快" },
    content: { score: 4, desc: "流行作品为主" },
    sincere: { score: 5, desc: "无套路，体验友好" },
    summary:
      "设计年轻、上手简单，适合第一次找漫画站的新人，广告适中，加载流畅，体验友好。",
    desc: "漫语潮面向年轻用户设计，界面新潮、上手门槛低，非常适合第一次找漫画网站的新人。广告控制适中，浏览过程不会过于打扰。加载采用较新的技术方案，整体速度流畅。内容以当下流行作品为主，更新及时。整体无套路、体验友好，良心程度高。",
    pros: ["界面年轻上手快", "加载流畅", "无套路体验友好"],
    cons: ["老作品收录有限", "账号体系待完善"],
    img: "https://readdy.ai/api/search-image?query=fresh%20youthful%20manga%20website%20concept%20illustration%20with%20colorful%20characters%20and%20screens%2C%20teal%20and%20coral%20vibrant%20palette%2C%20modern%20flat%20art%2C%20energetic%20clean%20composition&width=800&height=600&seq=manyuchao-cover&orientation=landscape",
  },
  {
    slug: "manhua-zhen",
    name: "漫画针",
    tagline: "避雷重点对象，谨慎使用",
    category: "慎用站点",
    rating: 2.8,
    ads: { score: 1, desc: "广告极多，弹窗频繁" },
    speed: { score: 3, desc: "一般，页面较重" },
    content: { score: 3, desc: "资源尚可" },
    sincere: { score: 2, desc: "存在诱导套路" },
    summary:
      "这是需要重点避雷的典型：广告多、弹窗频繁，存在诱导下载与付费套路，资源虽可但体验很差。",
    desc: "漫画针是典型的「避雷」对象。广告密度极高，进入页面弹窗频繁，翻页时也常跳出诱导下载、诱导付费的页面，阅读体验很差。加载速度一般，页面资源较重。内容资源尚可，但基于糟糕的广告与套路行为，强烈建议谨慎使用，属于应该绕开的站点。",
    pros: ["资源收录尚可"],
    cons: ["广告弹窗极多", "存在诱导套路", "加载偏慢"],
    img: "https://readdy.ai/api/search-image?query=caution%20warning%20concept%20with%20manga%20characters%20and%20popup%20windows%20overlay%2C%20darker%20muted%20tone%20with%20red%20accents%2C%20flat%20illustration%2C%20cluttered%20busy%20composition%2C%20conceptual%20art&width=800&height=600&seq=manhuazhen-cover&orientation=landscape",
    badge: "避雷警示",
  },
];

export const reviewDimensions = [
  { key: "ads", label: "广告控制", desc: "广告数量、弹窗频率与阅读干扰程度" },
  { key: "speed", label: "加载速度", desc: "页面打开、图片加载与翻页流畅度" },
  { key: "content", label: "内容收录", desc: "作品覆盖面、更新及时度与图质" },
  { key: "sincere", label: "良心程度", desc: "是否免费、有无套路诱导、体验是否友好" },
];